import React, { useEffect } from "react";

import ActionList from "../../../templates/student/ActionList";
import {
  Context,
  FETCH_ACTION_LIST_SUCCESS,
  FETCH_ACTION_LIST_FAILURE,
  fetchActionList,
  submitRealization,
} from "../../../studentStore";
import * as MESSAGE from "../../../studentStore/messages";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useRequestStatus from "../../../hooks/useRequestStatus";
import Loading from "../../../molecules/Loading";
import Toast from "../../../molecules/Toast";
import { FETCH_FAILURE_MESSAGE } from "../../../studentStore/messages";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const [showMsg, setShowMsg] = React.useState<{
    text: string;
    type: string;
  }>({
    text: "",
    type: "",
  });
  const fetchActionListRequestStatus = useRequestStatus({
    lastAction: state.lastAction,
    successAction: FETCH_ACTION_LIST_SUCCESS,
    failureAction: FETCH_ACTION_LIST_FAILURE,
  });

  useEffect(() => {
    dispatch(fetchActionList());
  }, [dispatch]);

  useEffect(() => {
    if (fetchActionListRequestStatus === "error") {
      setShowMsg({
        text: FETCH_FAILURE_MESSAGE,
        type: "error",
      });
    }
  }, [fetchActionListRequestStatus]);

  useEffect(() => {
    if (state.success_message === MESSAGE.SUBMIT_REALIZATION_SUCCESS_MSG) {
      dispatch(fetchActionList());
    }
  }, [dispatch, state.success_message]);

  const handleSubmitRealization = React.useCallback(
    (lesson_id: number, content: string, realization_id: number | null) => {
      dispatch(peep(submitRealization(lesson_id, content, realization_id)));
    },
    [dispatch, peep],
  );

  if (fetchActionListRequestStatus === "loading") {
    return <Loading />;
  }

  return (
    <>
      {showMsg.text && (
        <Toast
          onClose={() =>
            setShowMsg({
              text: "",
              type: "",
            })
          }
          message={showMsg}
        />
      )}
      {fetchActionListRequestStatus === "success" && (
        <ActionList
          actionList={state.action_list}
          handleSubmitRealization={handleSubmitRealization}
          calling={calling}
        />
      )}
    </>
  );
};
